export default class Vendor {
  constructor(public id: number,
    public name: string = null,
    public address: string = null,
    public city: string = null,
    public state: string = null,
    public zipCode = null,
    public phoneNumber = null) { }

  static createFromRequest(request: any): Vendor {
    if (request.source !== null && request.source !== undefined) {
      const { sourceName, address, city, state, zipCode, phoneNbr } = request.source;
      return new Vendor(null, sourceName, address, city, state, zipCode, phoneNbr);
    } else if (request.vendorId === null || request.vendorId === undefined) {
      return new Vendor(request.vendorId);
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/models/vendor.ts